'use client'

import { AppInstallAccountsDs } from '@src/components/blocks/app-install-accounts-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { AppInstallAccountsLegacy, AppInstallAccountsProps } from './app-install-accounts-legacy'

export type { AppInstallAccountsProps }

export function AppInstallAccounts(props: AppInstallAccountsProps) {
  if (shouldUseDesignSystem()) {
    return <AppInstallAccountsDs {...props} />
  }
  return <AppInstallAccountsLegacy {...props} />
}
